import React from 'react';
import {NavLink} from "react-router-dom";
import { RiUserSettingsLine} from "react-icons/ri";
import {TbCategory2,  TbSmartHome} from "react-icons/tb";
import { useCart } from '../context/CartContext';

import {HiOutlineQueueList} from "react-icons/hi2";
import {LuUserRoundCog} from "react-icons/lu";
import {CgShoppingBag} from "react-icons/cg";



const Navbar = (props) => {
    const { cart } = useCart();

    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white nav-bar-app">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><TbSmartHome className='nav-icon'/></div>
                    <span>خانه</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/categories">
                    <div><TbCategory2 className='nav-icon'/></div>
                    <span>دسته ها</span>
                </NavLink>
                <NavLink className="nav-item nav-link d-none d-md-block " to="/search">
                    <div><RiUserSettingsLine className='nav-icon'/></div>
                    <span>جستجو</span>
                </NavLink>
                {
                    cart.length > 0 ?
                        <NavLink className="nav-item nav-link  " to="/cart">
                            <div>

                                <CgShoppingBag  className=' nav-icon  ' />

                            </div>
                            <span className="text-small-2 ">

                                سبدخرید

                                {cart.length > 0 && (
                                    <span className='badge bg-third-color text-white position-relative top-0 translate-middle rounded-pill small'>
                   {cart.length}
                </span>
                                )}
                            </span>
                        </NavLink>
                        :
                        <NavLink className="nav-item nav-link  " to="/orders">
                            <div><HiOutlineQueueList  className='nav-icon' /></div>
                            <span className="text-small-1 ">سفارش ها</span>
                        </NavLink>
                }

                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><LuUserRoundCog className='nav-icon'/></div>
                    <span>حساب من</span>
                </NavLink>



            </nav>

        </React.Fragment>
    );
};

export default Navbar;
